module.exports = __webpack_public_path__ + "static/informatyka/games/page037_game12/audio//z18s37-c1.mp3";